const FLIGHTNEXTDAY_UPDATED = (state, FlightNextDay) => {
  state.FlightNextDay = FlightNextDay
}

const REBOOK_UPDATED = (state, Rebook) => {
  state.Rebook = Rebook
}

export default {
  FLIGHTNEXTDAY_UPDATED,
  REBOOK_UPDATED
}
